import axios from "axios";
import { getSessionToken } from "../../utils/Auth/AuthUtils";

const API_URL = "/api/office";

// Get students
const getOfficeWeek = async (locationId) => {
  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.get(
    API_URL + "/week?location_id=" + locationId,
    config
  );
  //console.log("Offices Service ", response.data);
  return response.data;
};

//Edit student
const postOfficeWeek = async (officeWeekData) => {
  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.post(API_URL + "/week", officeWeekData, config);

  return response.data;
};

// update week status
const updateWeekStatus = async (officeWeekstatus) => {
  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.post(API_URL + "/weekstatus", officeWeekstatus, config);

  return response.data;
};


const officeWeekService = {
  getOfficeWeek,
  postOfficeWeek,
  updateWeekStatus,
};

export default officeWeekService;
